export default {
    setlanguageUserPreferedInCache(state, payload) {
        state.languageUserPrefered = payload
    },
    // updatestartupDatainfo(state, payload) {
    //     for(let key of Object.keys(payload)){
    //         state.startUpDataDetails[key] = payload[key]
    //     }    
    //     if(payload.key != undefined){
    //         state.startupDataInfo[payload.key] = payload.content
    //     }
    // },
};